import React, { useLayoutEffect, useRef } from "react";

import {
  getChartOptions,
  mapChartData,
} from "@src/features/total_fte_chart/utils/total_fte_utils";
import { MonthlyTotalFte } from "@src/types/dashboard_types";
import { Card, Alert } from "antd";
import {
  CategoryScale,
  Chart,
  ChartData,
  ChartOptions,
  Filler,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";
import "./total_fte_chart.less";

Chart.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler
);

export interface TotalFteChartProps {
  data: MonthlyTotalFte[];
  isLoading?: boolean;
  isScrollable?: boolean;
  isProjectEnded?: boolean;
}

const TotalFteChart: React.FC<TotalFteChartProps> = ({
  data = [],
  isLoading,
  isScrollable = false,
  isProjectEnded = false,
}) => {
  const chartData: ChartData<"line"> = mapChartData(data);
  const chartOptions: ChartOptions<"line"> = getChartOptions();

  const containerRef = useRef<HTMLDivElement>(null);
  const [chartWidth, setChartWidth] = React.useState<string>("100%");

  useLayoutEffect(() => {
    if (!isScrollable) return;
    const containerWidth = containerRef.current?.clientWidth ?? 0;
    const requiredWidth = (chartData.labels?.length ?? 0) * 30;

    setChartWidth(
      requiredWidth < containerWidth ? "100%" : `${requiredWidth}px`
    );
  }, [isScrollable, chartData.labels?.length]);

  return (
    <Card
      title="Total FTE"
      className="total-fte-chart"
      loading={isLoading}
      ref={containerRef}
    >
      <div
        className="total-fte-chart__line-chart"
        style={isScrollable ? { width: chartWidth } : undefined}
      >
        {isProjectEnded && (
          <div className="project-ended-notification">
            <Alert
              type="info"
              className="notification-banner"
              message={
                "No total FTE data shown here, because project timeline ended"
              }
            />
          </div>
        )}
        <Line
          height="300px"
          data={chartData}
          options={chartOptions}
          data-testid="total-fte-line-chart"
        />
      </div>
    </Card>
  );
};

export default TotalFteChart;
